<script setup>
    import {computed} from "vue";

    const props = defineProps({
        size: {
            type: String,
            default: 'sm',
            options: ['xs', 'sm', 'md', 'lg', 'xl']
        },
        styleType: {
            type: String,
            default: 'base',
            options: ['base', 'info', 'info-alt']
        }
    })

    const pillClasses = computed(() => {
        const sizes = {
            'line': 'rounded-full',
            'xs': 'px-1 pt-px pb-0.5 text-xs rounded-md text-xxs',
            'sm': 'px-2 py-1 text-xs rounded-xl',
            'md': 'px-3 py-1.5 text-sm rounded-md',
            'lg': 'px-4 py-2 text-base rounded-md',
        }

        const styles = {
            'base': 'bg-gray-100 border border-gray-200 text-gray-700',
            'success': 'bg-green-100 border border-green-200 text-green-700',
            'info': 'bg-blue-100 border border-blue-200 text-blue-700',
            'info-alt': 'text-fuchsia-700 border border-fuchsia-200 bg-fuchsia-50',
        }

        return [
            sizes[props.size],
            styles[props.styleType],
        ]
    })

</script>

<template>
    <div :class="pillClasses" class="inline-block font-medium">
        <slot></slot>
    </div>
</template>

<style scoped>

</style>
